import React from "react";
import clsx from "clsx";
import TimePickerInput from "../TimePickerInput/TimePickerInput";
import TaskManagerBuilderErrors from "./TaskManagerBuilderErrors";

class TaskManagerBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    // console.log("this.props.rake_task_name", this.props.rake_task_name);
    // console.log("this.props", this.props);
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">{this.renderGeneralForm()}</div>
        </div>
      </div>
    );
  }

  renderErrors() {
    var errors = TaskManagerBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = "";
    } else {
      var classname = "form-control";
    }
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("status")}</label>
              <br />
              <select
                id="status"
                name="task[status]"
                value={this.props.status || ""}
                onChange={this.props.onFieldChange}
                className="form-control"
              >
                <option value="enabled">{I18n.t("enabled")}</option>
                <option value="disabled">{I18n.t("Disabled")}</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("time_period")} </label>
              <br />
              <select
                id="time_period"
                name="task[time_period]"
                value={this.props.time_period || ""}
                onChange={this.props.onFieldChange}
                className={this.renderFieldClasses("time_period")}
              >
                {
                  this.props.rake_task_name == 'prices:set_pricing' ? (
                    <option value="every_day_at">{I18n.t("every_day")}</option>
                  ) : (
                    <>
                      <option value="every_day_at">{I18n.t("every_day")}</option>
                      <option value="every_hour_at">{I18n.t("every_hour")}</option>
                    </>
                  )
                }
              </select>
            </div>
          </div>
          {this.renderTimePicker()}
        </div>
      </div>
    );
  }

  renderTimePicker() {
    if (this.props.time_period == "every_day_at") {
      var { time_value } = this.props;
      
      if (typeof time_value === "string") {
        //create Javascript DateTime Object with correct time for time picker
        time_value = new Date("1970-01-01T" + this.props.time_value);
        time_value.setMinutes(0);
      }
      
      return (
        <div className="col-md-4">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{I18n.t("time_value")} </label>
            <br />
            <TimePickerInput
              timeInvervals={60}
              format={this.props.time_format}
              onChange={this.props.onChange.bind(this, "time_value")}
              selectedTime={time_value}
              offsetTime={false}
            />
          </div>
        </div>
      );
    }
  }
}

export default TaskManagerBuilderGeneral;
